import {useState} from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useFormik} from 'formik'
//import {requestPassword} from '../core/_requests'
import { useIntl } from 'react-intl'
import { getAuth, sendPasswordResetEmail } from 'firebase/auth'

const initialValues = {
  email: 'admin@demo.com',
}

const forgotPasswordSchema = Yup.object().shape({
  email: Yup.string()
    .email('Wrong email format')
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Email is required'),
})

export function ForgotPassword() {
  const [loading, setLoading] = useState(false)
  const [hasErrors, setHasErrors] = useState<boolean | undefined>(undefined)
  const [loginButton, setLoginButton] = useState(false)
	const intl = useIntl()
  const auth = getAuth()
  const formik = useFormik({
    initialValues,
    validationSchema: forgotPasswordSchema,
    onSubmit: (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      setHasErrors(undefined)
      setTimeout(() => {
        sendPasswordResetEmail(auth, values.email)
        .then(() => {
          console.log('Password reset email sent!')
          setHasErrors(false)
          setLoading(false)
          setLoginButton(true)
        })
        .catch((error) => {
          setHasErrors(true)
          setLoading(false)
          setSubmitting(false)
          setStatus('The login detail is incorrect')
          const errorCode = error.code;
          const errorMessage = error.message;
        });
       }, 1000)
    },
  })

  return (
    <form
      className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
      noValidate
      id='kt_login_password_reset_form'
      onSubmit={formik.handleSubmit}
    >
      <div className='text-center mb-10'>
        {/* begin::Title */}
        <h1 className='text-dark fw-bolder mb-3'>{intl.formatMessage({id: 'AUTH.GENERAL.FORGOT_BUTTON'})}</h1>
        {/* end::Title */}

        {/* begin::Link */}
        <div className='text-gray-500 fw-semibold fs-6'>
					{intl.formatMessage({id: 'AUTH.FORGOT.DESC'})}
        </div>
        {/* end::Link */}
      </div>

      {/* begin::Title */}
      {hasErrors === true && (
        <div className='mb-10 bg-gray-300 p-8 rounded'>
          <div className='text-gray-700 font-weight-bold'>
						{intl.formatMessage({id: 'AUTH.FORGOT.ERROR'})}
          </div>
        </div>
      )}

      {hasErrors === false && (
        <div className='mb-10 bg-gray-300 p-8 rounded'>
          <div className='text-gray-700 font-weight-bold'>{intl.formatMessage({id: 'AUTH.FORGOT.SUCCESS'})}</div>
        </div>
      )}
      {/* end::Title */}

      {/* begin::Form group */}
      <div className='fv-row mb-8'>
        <label className='form-label fw-bolder text-gray-900 fs-6'>{intl.formatMessage({id: 'APP.GENERAL.EMAIL'})}</label>
        <input
          type='email'
          placeholder={intl.formatMessage({id: 'AUTH.INPUT.EMAIL'})}
          autoComplete='off'
          {...formik.getFieldProps('email')}
          className={clsx(
            'form-control bg-transparent',
            {'is-invalid': formik.touched.email && formik.errors.email},
            {
              'is-valid': formik.touched.email && !formik.errors.email,
            }
          )}
        />
        {formik.touched.email && formik.errors.email && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.email}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group */}
      <div className='d-flex flex-wrap justify-content-center pb-lg-0'>
        <button type='submit' id='kt_password_reset_submit' className='btn btn-primary me-4'>
          {!loading && <span className='indicator-label'>{intl.formatMessage({id: 'APP.GENERAL.SUBMIT'})}</span>}
          {loading && (
            <span className='indicator-label'>
              {intl.formatMessage({id: 'APP.GENERAL.WAITMESSAGE'})}
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
        <Link to='/auth/login'>
          <button
            type='button'
            id='kt_login_password_reset_form_cancel_button'
            className='btn btn-light'
            disabled={formik.isSubmitting || !formik.isValid}
          >
            {intl.formatMessage({id: 'AUTH.GENERAL.BACK_BUTTON'})}
          </button>
        </Link>{' '}
      </div>
      {/* end::Form group */}
    </form>
  )
}
